module.exports = __webpack_public_path__ + "img/cs-basicEduS-4.fc20fa61.jpg";